/**
 * Scrolls to a specific row in a table container, centering it in the viewport
 * @param {HTMLElement} container - The scrollable container element
 * @param {number} targetIndex - The index of the row to scroll to
 * @param {string} rowSelector - CSS selector for table rows (default: "tbody tr")
 */
export function scrollToRow(container, targetIndex, rowSelector = "tbody tr") {
  if (!container || targetIndex === -1) return;

  const tableRows = container.querySelectorAll(rowSelector);
  if (!tableRows[targetIndex]) return;

  const targetRow = tableRows[targetIndex];
  const containerHeight = container.clientHeight;
  const rowTop = targetRow.offsetTop;
  const rowHeight = targetRow.offsetHeight;

  // Calculer la position pour centrer la ligne dans le conteneur
  const scrollPosition = rowTop - containerHeight / 2 + rowHeight / 2;

  // Scroller uniquement le conteneur, pas la page
  container.scrollTo({
    top: Math.max(0, scrollPosition),
    behavior: "smooth",
  });
}

/**
 * Scrolls to the first item in a data array that matches a condition
 * @param {HTMLElement} container - The scrollable container element
 * @param {Array} dataArray - Array of data items
 * @param {Function} findIndexFn - Function that returns the index of the current item (e.g., (item) => item.isCurrent)
 * @param {string} rowSelector - CSS selector for table rows (default: "tbody tr")
 */
export function scrollToCurrentItem(container, dataArray, findIndexFn, rowSelector = "tbody tr") {
  if (!container || !dataArray || !findIndexFn) return;

  const currentIndex = dataArray.findIndex(findIndexFn);
  if (currentIndex === -1) return;

  scrollToRow(container, currentIndex, rowSelector);
}
